var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_27970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4095 14.5456C27.4095 18.1662 25.9712 21.6385 23.411 24.1986C20.8509 26.7588 17.3786 28.1971 13.758 28.1971C10.1374 28.1971 6.66504 26.7588 4.10488 24.1986C1.54473 21.6385 0.106445 18.1662 0.106445 14.5456C0.106445 10.925 1.54473 7.45263 4.10488 4.89248C6.66504 2.33232 10.1374 0.894043 13.758 0.894043C17.3786 0.894043 20.8509 2.33232 23.411 4.89248C25.9712 7.45263 27.4095 10.925 27.4095 14.5456ZM20.6349 9.37505C20.513 9.25358 20.3679 9.15794 20.2082 9.09385C20.0485 9.02976 19.8775 8.99854 19.7055 9.00204C19.5334 9.00554 19.3638 9.04371 19.2069 9.11425C19.0499 9.18479 18.9088 9.28626 18.792 9.41259L12.8655 16.9636L9.29391 13.3903C9.0513 13.1642 8.73041 13.0412 8.39885 13.047C8.06729 13.0529 7.75094 13.1872 7.51645 13.4217C7.28196 13.6561 7.14765 13.9725 7.1418 14.3041C7.13595 14.6356 7.25902 14.9565 7.48509 15.1991L12.0003 19.7161C12.122 19.8375 12.2668 19.9332 12.4262 19.9974C12.5856 20.0616 12.7564 20.0931 12.9282 20.0899C13.1 20.0867 13.2695 20.0489 13.4264 19.9788C13.5833 19.9088 13.7245 19.8078 13.8416 19.6819L20.6537 11.1668C20.8859 10.9253 21.0142 10.6024 21.011 10.2674C21.0078 9.93244 20.8734 9.61204 20.6366 9.37505H20.6349Z",
    fill: "#479F76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_27970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.303,
    height: 27.303,
    fill: "white",
    transform: "translate(0.106445 0.894043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve_icon.b94d9f3a7aa26ca3557fdf1ee9291aed.svg";
export { ForwardRef as ReactComponent };